/**
 * Session Timer Component
 * Displays elapsed time since session started
 * Phase 7.1 - Session Management System
 */
import React, { useState, useEffect } from 'react';
/**
 * Format seconds as HH:MM:SS
 */
function formatTime(totalSeconds) {
    const hours = Math.floor(totalSeconds / 3600);
    const minutes = Math.floor((totalSeconds % 3600) / 60);
    const seconds = totalSeconds % 60;
    return [
        hours.toString().padStart(2, '0'),
        minutes.toString().padStart(2, '0'),
        seconds.toString().padStart(2, '0')
    ].join(':');
}
/**
 * SessionTimer Component
 */
export default function SessionTimer({ isActive, startTime }) {
    const [elapsedSeconds, setElapsedSeconds] = useState(0);
    useEffect(() => {
        if (!isActive || !startTime) {
            setElapsedSeconds(0);
            return;
        }
        // Calculate initial elapsed time
        const initialElapsed = Math.floor((Date.now() - startTime.getTime()) / 1000);
        setElapsedSeconds(initialElapsed);
        // Update every second
        const interval = setInterval(() => {
            const elapsed = Math.floor((Date.now() - startTime.getTime()) / 1000);
            setElapsedSeconds(elapsed);
        }, 1000);
        return () => clearInterval(interval);
    }, [isActive, startTime]);
    if (!isActive) {
        return (React.createElement("div", { style: styles.container },
            React.createElement("div", { style: styles.label }, "Session Timer"),
            React.createElement("div", { style: styles.timeInactive }, "--:--:--"),
            React.createElement("div", { style: styles.status }, "Not Started")));
    }
    return (React.createElement("div", { style: styles.container },
        React.createElement("div", { style: styles.label }, "Session Timer"),
        React.createElement("div", { style: styles.timeActive }, formatTime(elapsedSeconds)),
        React.createElement("div", { style: styles.statusActive }, "\u25CF Recording")));
}
const styles = {
    container: {
        padding: '16px',
        backgroundColor: '#2b2b2b',
        borderRadius: '8px',
        textAlign: 'center',
        minWidth: '200px'
    },
    label: {
        fontSize: '12px',
        color: '#999',
        marginBottom: '8px',
        textTransform: 'uppercase',
        letterSpacing: '1px'
    },
    timeActive: {
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#4CAF50',
        fontFamily: 'monospace',
        marginBottom: '8px'
    },
    timeInactive: {
        fontSize: '32px',
        fontWeight: 'bold',
        color: '#666',
        fontFamily: 'monospace',
        marginBottom: '8px'
    },
    statusActive: {
        fontSize: '14px',
        color: '#4CAF50',
        fontWeight: '500'
    },
    status: {
        fontSize: '14px',
        color: '#999',
        fontWeight: '500'
    }
};
